import { useState } from 'react';
import { cn } from '../../../lib/utils';

/**
 * 1–10 rating picker. The exact selected (or hovered) value is solid, the
 * steps below it are tinted, everything above stays neutral.
 */
const RatingScale = ({
  value = 0,
  onChange,
  disabled = false,
  className,
  label = 'Rate this team from 1 to 10',
}) => {
  const [hovered, setHovered] = useState(0);
  const active = disabled ? value : hovered || value;

  function stepClass(n) {
    if (n === active) return 'border-heat bg-heat text-heat-foreground';
    if (n < active) return 'border-heat/50 bg-heat/15 text-heat';
    return 'border-border/60 text-muted-foreground';
  }

  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn('flex gap-1', className)}
      onMouseLeave={() => setHovered(0)}
    >
      {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          aria-checked={value === n}
          aria-label={`Rate ${n} out of 10`}
          disabled={disabled}
          onClick={() => onChange?.(n)}
          onMouseEnter={() => setHovered(n)}
          onFocus={() => setHovered(n)}
          onBlur={() => setHovered(0)}
          className={cn(
            'h-9 min-w-0 flex-1 rounded-sm border font-mono text-xs tabular-nums transition-colors duration-150',
            stepClass(n),
            disabled ? 'cursor-default opacity-50' : 'hover:border-heat/60'
          )}
        >
          {n}
        </button>
      ))}
    </div>
  );
};

export default RatingScale;
